<div class="viewer-container">
  <div class="close-button-container">
    <mat-icon class="close-button mat-icon" aria-hidden="true" data-mat-icon-type="font" (click)="dialogRef.close()"
      >close</mat-icon
    >
  </div>
  <div class="photo-modal-title-container">
    <h2 class="photo-modal-title">Download Your Photos and GIF</h2>
  </div>
  <div class="viewer-content">
    <!-- TODO: Revisit the logic about social media integration -->
    <!-- <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      [(ngModel)]="selectedToShare"
      >
      <div id="imageGrid">
        <div class="placeholder" *ngFor="let photo of photos">
          <div class="checkbox-container">
            <mat-radio-button class="example-radio-button" [value]="photo.id"></mat-radio-button>
          </div>
          <img alt="Photo" [src]="photo.url" />
        </div>
      </div>
    </mat-radio-group> -->

    <div id="imageGrid">
      @for (photo of photos; track photo) {
        <div class="placeholder">
          <img alt="Photo" [src]="photo.url" />
        </div>
      }
    </div>
  </div>
  <div class="photo-modal-dividing-line"></div>
  <div class="photo-modal-footer">
    <!-- TODO: Revisit the logic about social media integration -->
    <!-- <button
    data-testid="photo-booth-share-picture"
    mat-raised-button
    [mat-dialog-close]="selectedToShare"
    (click)="onShareClick()"
    class="photo-modal-buttons-container photo-modal-button-secondary"
    >
    Share
    <mat-icon class="photo-modal-button-secondary-icon" data-mat-icon-type="font">share </mat-icon>
  </button> -->
    <button
      data-testid="photo-booth-download-picture"
      id="downloadButton"
      mat-raised-button
      (click)="onDownloadButtonClick()"
      class="photo-modal-buttons-container photo-modal-button-primary"
    >
      Download to computer
      <mat-icon class="photo-modal-button-primary-icon" data-mat-icon-type="font">vertical_align_bottom</mat-icon>
    </button>
  </div>
</div>
@if (isLoading) {
  <div class="loading-container">
    <app-loading></app-loading>
    <span class="font-s">{{ loadingText }}</span>
  </div>
}
